import styled from 'styled-components'

type Props = {
	size?: number
	shouldOverlapCard?: boolean
}

export const Wrapper = styled.div<Props>`
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1;

	> svg {
		width: 100%;
		max-width: 200px;
		max-height: 100px;
	}
`
